import React, { Component } from "react"
import Lottie from "lottie-react"

import { LOADONG } from "../constants/lottie"

class Loading extends Component {
    constructor() {
        super()
    }

    render = () => {
        return (
            <div className="loading-block">
                <Lottie animationData={LOADONG} loop={true} />
            </div>
        )
    }

}

export default Loading